<template>
  <el-aside width="200px">
    <el-menu
      class="aside-menu"
      :default-active="activeIndex"
      background-color="#545c64"
      text-color="#ffffff"
      active-text-color="#ffd04b"
    >
      <el-menu-item class="logo">
        <span>Acquirer</span>
      </el-menu-item>
      <el-menu-item index="/dashboard">
        <router-link to="/dashboard">
          <i class="el-icon-odometer"></i>
          <span>Dashboard</span>
        </router-link>
      </el-menu-item>
      <el-menu-item index="/transactions">
        <router-link to="/transactions">
          <i class="el-icon-s-finance"></i>
          <span>Transactions</span>
        </router-link>
      </el-menu-item>
      <el-menu-item index="/payment/make">
        <router-link to="/payment/make">
          <i class="el-icon-bank-card"></i>
          <span>Make Payment</span>
        </router-link>
      </el-menu-item>
      <el-menu-item index="/invoice">
        <router-link to="/invoice">
          <i class="el-icon-document"></i>
          <span>Invoice</span>
        </router-link>
      </el-menu-item>
      <el-menu-item index="/generate/url">
        <router-link to="/generate/url">
          <i class="el-icon-link"></i>
          <span>Generate URL</span>
        </router-link>
      </el-menu-item>
      <el-menu-item index="/account" v-if="userData.admin">
        <router-link to="/account">
          <i class="el-icon-s-management"></i>
          <span>Account</span>
        </router-link>
      </el-menu-item>
      <el-menu-item index="/profile">
        <router-link to="/profile">
          <i class="el-icon-s-custom"></i>
          <span>Profile</span>
        </router-link>
      </el-menu-item>

      <el-menu-item index="/user/manager" v-if="userData.admin">
        <router-link to="/user/manager">
          <i class="el-icon-s-tools"></i>
          <span>User Manager</span>
        </router-link>
      </el-menu-item>

    </el-menu>
  </el-aside>
</template>

<script>

export default {
  data() {
    return {
      userData : {},
      activeIndex: "/dashboard"
    };
  },
  methods: {
    getUser() {
      this.userData = this.$store.getters.user;
    },
    actived() {
      this.activeIndex = this.$route.path;
    }
  },
  created() {
    this.actived();
    this.getUser()
  }
};
</script>
